<div class="p-3">
  <!-- STEP 1: Seleziona il prodotto da sostituire -->
  <ng-container *ngIf="step === 1">
    <p class="mb-3 text-500">Seleziona il prodotto dell'ordine che vuoi sostituire.</p>

    <p-table
      [value]="items"
      selectionMode="single"
      [(selection)]="selectedOldItem"
      dataKey="id"
      styleClass="p-datatable-sm"
      responsiveLayout="scroll">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 3rem"></th>
          <th>Nome</th>
          <th>Cod. interno</th>
          <th>Cod. commessa</th>
          <th>Qtà</th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-item>
        <tr
          [pSelectableRow]="item"
          (click)="selectOldItem(item)"
          style="cursor: pointer">
          <td>
            <p-radioButton
              [value]="item"
              [(ngModel)]="selectedOldItem"></p-radioButton>
          </td>
          <td>{{ item.name || '—' }}</td>
          <td>{{ item.code_internal || '—' }}</td>
          <td>{{ item.agreement_code || '—' }}</td>
          <td>{{ item.qty ?? '—' }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td
            colspan="5"
            class="text-center text-500">
            Nessun prodotto nell'ordine
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="flex justify-content-end mt-3 gap-2">
      <p-button
        label="Annulla"
        styleClass="p-button-outlined"
        (onClick)="close()"></p-button>
      <p-button
        label="Avanti"
        icon="pi pi-arrow-right"
        iconPos="right"
        [disabled]="!selectedOldItem"
        (onClick)="goToStep2()"></p-button>
    </div>
  </ng-container>

  <!-- STEP 2: Seleziona nuovo prodotto + impatto -->
  <ng-container *ngIf="step === 2">
    <!-- Riepilogo prodotto selezionato -->
    <div class="mb-3 p-3 surface-100 border-round">
      <span class="text-500 text-sm block mb-1">Prodotto da sostituire</span>
      <span class="font-semibold">{{ selectedOldItem?.name || '—' }}</span>
      <span class="text-500 ml-2 text-sm">{{ selectedOldItem?.code_internal || '' }}</span>
    </div>

    <!-- Selezione nuovo prodotto -->
    <div class="field mb-3">
      <label class="font-semibold block mb-2">Nuovo prodotto</label>

      <!-- Prodotto selezionato (se presente) -->
      <div
        *ngIf="hasNewProduct"
        class="mb-2 p-2 surface-50 border-1 border-round surface-border">
        <span class="font-medium">{{ newProductLabel }}</span>
      </div>
      <div
        *ngIf="!hasNewProduct"
        class="mb-2 p-2 surface-50 border-1 border-round surface-border text-500">
        Nessun prodotto selezionato
      </div>

      <div class="flex gap-2">
        <p-button
          label="Prodotti commessa"
          icon="pi pi-search"
          styleClass="p-button-outlined p-button-sm"
          (onClick)="openAgreementProductPicker()"></p-button>
      </div>
    </div>

    <!-- Prezzo / IVA (visibili dopo impact, solo se ci sono unità sostituibili) -->
    <ng-container
      *ngIf="
        hasNewProduct &&
        impact &&
        !loadingImpact &&
        impact.blocking_ddt_deliveries === 0 &&
        impact.replaceable_qty > 0
      ">
      <div class="formgrid grid mb-3">
        <div class="field col-12 md:col-6">
          <label class="font-semibold block mb-1">Prezzo unitario (€)</label>
          <p-inputNumber
            [(ngModel)]="newPrice"
            mode="decimal"
            [minFractionDigits]="2"
            [maxFractionDigits]="4"
            [min]="0"
            inputStyleClass="w-full"
            styleClass="w-full"
            placeholder="0.00"></p-inputNumber>
        </div>
        <div class="field col-12 md:col-6">
          <label class="font-semibold block mb-1">IVA</label>
          <p-dropdown
            [options]="vatList"
            [(ngModel)]="selectedVat"
            optionLabel="label"
            placeholder="Seleziona IVA"
            styleClass="w-full"
            [showClear]="true"></p-dropdown>
        </div>
      </div>
    </ng-container>

    <!-- Impatto -->
    <ng-container *ngIf="hasNewProduct">
      <p-progressBar
        *ngIf="loadingImpact"
        mode="indeterminate"
        [style]="{ height: '4px' }"
        class="mb-3"></p-progressBar>

      <div
        *ngIf="impact && !loadingImpact"
        class="mb-3">
        <!-- BLOCCANTE: consegne con DDT -->
        <div
          *ngIf="impact.blocking_ddt_deliveries > 0"
          class="p-3 border-1 border-round border-red-400 bg-red-50 mb-2">
          <p class="font-semibold mb-2 text-red-700">
            <i class="pi pi-ban mr-2"></i>
            Sostituzione bloccata
          </p>
          <p class="mb-0 text-red-700">
            <strong>{{ impact.blocking_ddt_deliveries }}</strong>
            {{
              impact.blocking_ddt_deliveries === 1
                ? 'consegna coinvolta ha DDT associati'
                : 'consegne coinvolte hanno DDT associati'
            }}. La sostituzione non è consentita.
          </p>
        </div>

        <!-- BLOCCANTE: tutte le unità già assetizzate -->
        <div
          *ngIf="impact.blocking_ddt_deliveries === 0 && impact.replaceable_qty === 0"
          class="p-3 border-1 border-round border-red-400 bg-red-50 mb-2">
          <p class="font-semibold mb-2 text-red-700">
            <i class="pi pi-ban mr-2"></i>
            Sostituzione non possibile
          </p>
          <p class="mb-0 text-red-700">
            Tutte le <strong>{{ impact.assetized_qty }}</strong> unità di questo prodotto sono già
            assetizzate. Non ci sono unità da sostituire.
          </p>
        </div>

        <!-- Impatto normale -->
        <div
          *ngIf="impact.blocking_ddt_deliveries === 0 && impact.replaceable_qty > 0"
          class="p-3 surface-50 border-1 border-round surface-border">
          <p class="font-semibold mb-2">
            <i class="pi pi-info-circle mr-2 text-yellow-500"></i>
            Impatto della sostituzione:
          </p>
          <ul class="pl-3 mb-2">
            <li>
              <strong>{{ impact.affected_deliveries }}</strong>
              {{
                impact.affected_deliveries === 1
                  ? 'consegna verrà aggiornata'
                  : 'consegne verranno aggiornate'
              }}
            </li>
            <li>
              <strong>{{ impact.affected_tickets }}</strong>
              {{
                impact.affected_tickets === 1
                  ? 'ticket (staging/verbale) verrà aggiornato'
                  : 'ticket (staging/verbale) verranno aggiornati'
              }}
            </li>
            <li *ngIf="impact.assetized_qty > 0">
              <strong>{{ impact.replaceable_qty }}</strong> unità verranno sostituite (<strong>{{
                impact.assetized_qty
              }}</strong>
              già assetizzate rimarranno invariate)
            </li>
          </ul>
          <p class="text-500 text-sm mb-0">
            Le entità in stato definitivo non verranno modificate.
          </p>
        </div>
      </div>
    </ng-container>

    <!-- Bottoni -->
    <div class="flex justify-content-between mt-4 gap-2">
      <p-button
        label="Indietro"
        icon="pi pi-arrow-left"
        styleClass="p-button-outlined"
        (onClick)="goBack()"></p-button>
      <div class="flex gap-2">
        <p-button
          label="Annulla"
          styleClass="p-button-outlined p-button-secondary"
          (onClick)="close()"></p-button>
        <p-button
          label="Sostituisci"
          icon="pi pi-check"
          styleClass="p-button-danger"
          [disabled]="
            !hasNewProduct ||
            !impact ||
            loadingImpact ||
            executing ||
            (impact && impact.blocking_ddt_deliveries > 0) ||
            (impact && impact.replaceable_qty === 0)
          "
          [loading]="executing"
          (onClick)="confirmReplace()"></p-button>
      </div>
    </div>
  </ng-container>
</div>
